import React, { useMemo } from 'react';
import { STATUS_COLORS, getProviderInfo } from '../../utils/providerMap';
import '../../styles/results-ui.css';

export default function OrderCard({ orderVm, isExpanded = false, onToggle, onOpen, size = 'regular' }) {
  const statusKey = orderVm.status || 'processing';
  const statusColor = STATUS_COLORS[statusKey] || '#94a3b8';

  // Format creation date for better readability
  const formatDate = (timestamp) => {
    if (!timestamp) return 'Unknown';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };

  const createdAtText = useMemo(() => formatDate(orderVm.meta.createdAt), [orderVm.meta.createdAt]);

  return (
    <div className={`order-card-ui ${size} ${isExpanded ? 'expanded' : ''}`}>
      <div className="order-card-header" onClick={(e)=>{ e.stopPropagation(); onToggle && onToggle(); }}>
        
        {/* Left Section: Status + Order Info */}
        <div className="order-left-section">
          {/* Status and Title Row */}
          <div className="order-title-row">
            <div className="status-chip" style={{ background: `${statusColor}33` }}>
              <span style={{ width: 8, height: 8, background: statusColor, borderRadius: '50%' }} />
              <span>{(statusKey || 'Processing').charAt(0).toUpperCase() + (statusKey || 'Processing').slice(1)}</span>
            </div>
            <div className="order-title">{orderVm.label}</div>
          </div>
          
          {/* Compact Order Details */}
          <div className="order-details-compact">
            {/* First Row: Date, User */}
            <div className="order-meta-row">
              <span className="order-date">{createdAtText}</span>
              {orderVm.meta.requestedBy && (
                <span className="order-user">by {orderVm.meta.requestedBy}</span>
              )}
            </div>
            
            {/* Second Row: Providers (if space allows) */}
            {orderVm.providers?.length > 0 && (
              <div className="providers-compact">
                {orderVm.providers.map((provider, index) => {
                  const providerInfo = getProviderInfo(provider.providerId);
                  return (
                    <span key={index} className="provider-badge-compact" style={{ color: providerInfo.color }}>
                      {providerInfo.icon && <providerInfo.icon />}
                      {provider.name}
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Right Section: Stats + Action */}
        <div className="order-right-section">
          <div className="order-stats-compact">
            <div className="stat-item-compact">
              <span className="stat-value-compact">{orderVm.stats.totalJobs}</span>
              <span className="stat-label-compact">Jobs</span>
            </div>
            <div className="stat-item-compact">
              <span className="stat-value-compact">{orderVm.stats.completedJobs || 0}</span>
              <span className="stat-label-compact">Done</span>
            </div>
          </div>
          <button className="btn-primary btn-sm" onClick={(e)=>{ e.stopPropagation(); onOpen && onOpen(); }}>
            View Results
          </button>
          
          {/* Order ID in bottom right */}
          <div className="order-id-bottom">
            ID: {orderVm.id.slice(-8)}
          </div>
        </div>
      </div>
      
      {isExpanded && (
        <div className="order-expanded-content">
          {/* children (jobs) rendered by parent container below header */}
        </div>
      )}
    </div>
  );
}


